import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

export interface DropdownItem {
  label: string;
  value?: any;
  disabled?: boolean;
  icon?: any;
  subitems?: DropdownItem[];
  parentSelectable?: boolean;
}
@Component({
  selector: 'app-sectioned-dropdown',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './sectioned-dropdown.component.html',
  styleUrls: ['./sectioned-dropdown.component.css']
})
export class SectionedDropdownComponent {
  @Input() items: DropdownItem[] = [];
  @Input() placeholder: string = 'Select an option';
  @Input() selectedValue: any = null;
  @Input() disabled: boolean = false;
  @Input() width: string = '100%';
  @Input() maxHeight: string = '300px';

  @Output() itemSelected = new EventEmitter<DropdownItem>();
  @Output() selectedValueChange = new EventEmitter<any>();

  isOpen = false;
  insideClick = false;

  @HostListener('click')
  onClick() {
    this.insideClick = true;
  }

  @HostListener('document:click')
  onClickOut() {
    if (!this.insideClick) {
      this.isOpen = false;
    }
    this.insideClick = false;
  }

  toggleDropdown() {
    if (!this.disabled) {
      this.isOpen = !this.isOpen;
    }
  }

  selectItem(item: DropdownItem) {
    if (!item.disabled) {
      this.selectedValue = item.value ?? item.label;
      this.itemSelected.emit(item);
      this.selectedValueChange.emit(this.selectedValue);
      this.isOpen = false;
    }
  }

  getSelectedLabel(): string {
    let selected: DropdownItem | undefined = undefined;
    if(this.items != null) {
      selected = this.items.find(item =>
        (item.value ?? item.label) === this.selectedValue
      );

      if (!selected) {
        for (const item of this.items) {
          if (item.subitems) {
            selected = item.subitems.find(subitem =>
              (subitem.value ?? subitem.label) === this.selectedValue
            );
            if (selected) break;
          }
        }
      }
    }
    return selected?.label ?? this.placeholder;
  }
}
